import {
  setAuthorizationToken,
  updateLocalStorage,
  updateLocalStorageTerms
} from './persistance';
import * as types from './actionTypes';
import AuthApi from '../api/AuthApi';
import AccountApi from '../api/AccountApi';

import { pushData, pushGAAction } from '../utils/gtm';
import auth0Logout from '../utils/auth0/logout';

/**
 * User configuration (getView)
 */
export const updateConfig = config => ({
  type: types.UPDATE_CONFIG_SUCCESS,
  config
});

const setCurrentRole = role => ({
  type: types.SET_CURRENT_ROLE,
  role
});

export function logout() {
  auth0Logout();
}

export const fetchConfig = roleId => {
  if (roleId !== undefined) {
    return (dispatch, getState) =>
      AuthApi.getView(roleId)
        .then(config => {
          if (!config.success) {
            dispatch(logout({}));
          } else {
            dispatch(updateConfig(config));
          }
          return getState();
        })
        .catch(() => {
          sessionStorage.clear();
          dispatch(logout({}));
        });
  }
};

export const changeCurrentRole = role => dispatch => {
  dispatch(setCurrentRole(role));
  return dispatch(fetchConfig(role.value));
};

/**
 * terms and conditions
 */
export const userAcceptTerms = () => ({
  type: types.USER_ACCEPT_TERMS_SUCCESS
});

export const acceptTerms = () => dispatch =>
  AccountApi.acceptTerms().then(data => {
    if (data.success) {
      updateLocalStorageTerms(false);
      dispatch(userAcceptTerms());
    }
  });

// .catch(err => errorHandler(err, dispatch));

/**
 * User authentication
 */

export function setCurrentUser(data) {
  const userData = Object.assign({}, data, {
    isAuthenticated: Boolean(localStorage.getItem('auth/token'))
  });

  // inject Raven setContext method to associate client side errors with user data
  try {
    Raven.setUserContext({
      email: userData.username
    });
  } catch (err) {
    console.log(err);
  }

  return {
    type: types.SET_CURRENT_USER_SUCCESS,
    userData
  };
}

export function refreshToken() {
  return dispatch => {
    const refreshToken = localStorage.getItem('auth/refreshToken');
    if (refreshToken) {
      AuthApi.getRefreshedToken(refreshToken);
    } else {
      dispatch(logout());
    }
  };
}

export const userLoggedOut = () => ({
  type: types.USER_LOGGED_OUT
});

export function userForgotPassword(username) {
  return {
    type: types.FORGOT_PASSWORD_SUCCESS,
    username
  };
}

export function userResetPassword(email, token, newPassword) {
  return {
    type: types.RESET_PASSWORD_SUCCESS,
    email,
    token,
    newPassword
  };
}

export function validateToken(email, token) {
  return {
    type: types.USER_ACCEPT_TERMS_SUCCESS,
    email,
    token
  };
}

const setUserIdleStatus = idle => ({
  type: types.SET_USER_IDLE,
  idle
});

const setLogoutWarningDialog = showWarningDialog => ({
  type: types.SET_DISPLAY_LOGOUT_WARNING_DIALOG,
  showWarningDialog
});

const setLogoutDialog = showLogoutDialog => ({
  type: types.SET_DISPLAY_LOGOUT_DIALOG,
  showLogoutDialog
});

export const changeUserIdleStatus = idle => dispatch => {
  dispatch(setUserIdleStatus(idle));
};

export const clientSideLogout = dispatch => {
  // update stored data
  setAuthorizationToken();
  updateLocalStorage();
  updateLocalStorageTerms();

  pushData({ userId: null });
  pushGAAction('AUTH', 'logout');

  dispatch(userLoggedOut());
  dispatch(setCurrentUser({}));
  dispatch(updateConfig({}));
  // remove associated user data from sentry client side error report
  try {
    Raven.setUserContext();
  } catch (err) {
    console.log(err);
  }
};

export function legacyLogout() {
  return dispatch => {
    AuthApi.logout()
      .then(data => {
        // Server side token expiry successful - proceed with client side logout cleanup
        if (data.success) {
          clientSideLogout(dispatch);
        } else {
          // Server side token expiry unssuccessful - don't proceed with client side logout cleanup
          // errorHandler(data.serverError, dispatch);
          console.error(data.serverError);
          // throw new Error(data.serverError);
        }
      })
      .catch(err => {
        // In case of API failure just do the clientside logout console erroring the failure reason.
        console.error(`logout failure${err}`);
        clientSideLogout(dispatch);
        // errorHandler(err, dispatch);
        throw err;
      });
  };
}

export function login(username, password) {
  return function(dispatch) {
    return AuthApi.getToken(username, password)
      .then(data => {
        dispatch(setCurrentUser(data));
      })
      .catch(err => {
        // errorHandler(err, dispatch);
        throw err;
      });
  };
}

export function legacyLogin() {
  return function(dispatch) {
    return AuthApi.getLegacyToken()
      .then(data => {
        dispatch(setCurrentUser(data));
      })
      .catch(err => {
        // errorHandler(err, dispatch);
        throw err;
      });
  };
}

export function loginExternal(code) {
  return function(dispatch) {
    return AuthApi.getExternalToken(code)
      .then(data => {
        dispatch(setCurrentUser(data));
        return data;
      })
      .catch(err => {
        // errorHandler(err, dispatch);
        throw err;
      });
  };
}

export function ForgotPassword(username) {
  return function(dispatch) {
    return AuthApi.forgotPassword(username).then(data => {
      console.log(data);
      const { success, serverError } = data;
      dispatch(userForgotPassword(username));
      return {
        success,
        serverError
      };
    });
    // .catch(err => errorHandler(err, dispatch));
  };
}

export function ResetPassword(email, token, newPassword) {
  return function(dispatch) {
    return AuthApi.resetPassword(email, token, newPassword).then(data => {
      const { success, serverError } = data;
      dispatch(userResetPassword(email, token, newPassword));
      return {
        success,
        serverError
      };
    });
    // .catch(err => errorHandler(err, dispatch));
  };
}

export function resetPasswordValidateToken(email, token) {
  return function(dispatch) {
    return AuthApi.resetPasswordValidateToken(email, token)
      .then(data => {
        const { success, serverError } = data;
        dispatch(validateToken(email, token));
        return {
          success,
          serverError
        };
      })
      .catch(error => {
        throw error;
      });
  };
}

export function displayLogoutWarningDialog() {
  return function(dispatch) {
    dispatch(setLogoutWarningDialog(true));
  };
}

export function displayLogoutDialog() {
  return function(dispatch) {
    dispatch(setLogoutDialog(true));
  };
}

export function hideLogoutWarningDialog() {
  return function(dispatch) {
    dispatch(setLogoutWarningDialog(false));
  };
}

export function hideLogoutDialog() {
  return function(dispatch) {
    dispatch(setLogoutDialog(false));
  };
}



// WEBPACK FOOTER //
// ./src/auth/actions.js